import { render, staticRenderFns } from "./ContractUpdate.vue?vue&type=template&id=3867e5d6&scoped=true&"
import script from "./ContractUpdate.vue?vue&type=script&lang=js&"
export * from "./ContractUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ContractUpdate.vue?vue&type=style&index=0&id=3867e5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867e5d6",
  null
  
)

export default component.exports